<template>
    <div id="footers">
        <div class="link"><a target="_blank" href="//creaction-network.com/" rel="nofollow"> About Us </a>
            | <a target="_blank" href="//profile.creaction-network.com/static-page/privacy-policy-en.html"> Privacy Policy  </a>
            | <a  target="_blank" href="//profile.creaction-network.com/static-page/terms-of-service-en.html"> Terms of Service </a>
        </div>
        <div>©2020 Creaction Network Limited. All rights reserved</div>
        <div style="margin-top: 2px;">
            All trademarks referenced herein are the properties of their
            respective owners
        </div>
    </div>
</template>
<script>
export default {
    name: "footer-element"
};
</script>

<style scoped>
#footers {
    width: 100%;
    height: 70px;
    background-color: rgba(40, 37, 31, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #847d6e;
    margin-top: 50px;
    font-family: Arial;
    font-size: 14px;

}
.link{
    margin-bottom: 6px;

}
    #footers  a{
        color: #847d6e;
        text-decoration: none;
    }
</style>
